import React, {useEffect, useState} from 'react';
import Papa from 'papaparse';

const CsvViewerUI = ({ docs }: { docs: Array<{ uri: string }> }) => {

    const [csvData, setCsvData] = useState<string[][] | null>(null);

    useEffect(() => {
        const url: string = docs?.[0]?.uri || '';

        if (url) {
            fetch(url)
                .then((res) => res.text())
                .then((csvText) => {
                    const parsed = Papa.parse(csvText, { skipEmptyLines: true });
                    if (!parsed.errors.length) {
                        setCsvData(parsed.data as string[][]);
                    }
                });
        }
    }, [docs]);

    if (!csvData) return null;

    return (
        <>
            <table className='csv-viewer-table'>
                <thead>
                    <tr>
                        {csvData[0]?.map((cell, idx) => (
                            <th key={idx}>
                                {cell}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {csvData.slice(1).map((row, rowIdx) => (
                        <tr key={rowIdx}>
                            {row.map((cell, cellIdx) => (
                                <td key={cellIdx}>
                                    {cell}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    )
}

export default CsvViewerUI;